module.exports = __webpack_public_path__ + "assets/img/panda_QR.a870b7ef.png";